import React from 'react'

function AutoPayoutReport() {
  return (
    <div>AutoPayoutReport</div>
  )
}

export default AutoPayoutReport